import { css } from '@emotion/react';

import { Img } from '@zapier/design-system';
import { Invitation } from '@zapier/authentication';

type Props = {
  invitation: Invitation;
};

const rootStyle = css`
  align-items: center;
  display: grid;
  grid-auto-flow: column;
  grid-gap: 10px;
  justify-content: center;
`;

export function InvitationTitle({ invitation }: Props) {
  return (
    <div css={rootStyle}>
      <span>Join {invitation.account.name} on Zapier</span>
      {invitation.account?.logoUrl && (
        <Img
          alt="Account icon"
          ariaHidden={true}
          src={invitation.account?.logoUrl}
          width={32}
        />
      )}
    </div>
  );
}
